export interface AccessArrangementResultListing {
  noExamRegistered: boolean;
  accessArrangementOpen: boolean;
  accessArrangementResultModels: AccessArrangementResult[];
}

export interface AccessArrangementResult {
  uuid: string;
  applicationDateTime: string;
  applicationId: string;
  examLevels: string;
  amendmentDateTime: string;
  amendmentDraft: boolean;
  requestStatus?: ApplicationStatus;
  aaOutcomeLastUpdateDate?: string;
}

export enum ApplicationStatus {
  COMPLETED = 'Completed',
  SUBMITTED = 'Submitted',
  PROCESSING = 'Processing',
  DRAFT = 'Draft',
  WITHDRAWN = 'Withdrawn',
}
